import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import OperateTitle from '@/pages/Maintenance/Executive/components/OperateTitle';
import Variables from '@/pages/Maintenance/Executive/components/Variables';
import { setComponentIpVariables, setComponentVariables } from '@/slices/execComponentSlice';
import ConfigSteps from './Steps';

function Main({
  currentHosts,
  currentIpVariables,
  currentVariables,
  setComponentVariables,
  setComponentIpVariables,
}) {
  const [searchParams] = useSearchParams();
  const clusterType = Number(searchParams.get('clusterType'));

  return (
    <Root className='fadeIn'>
      <OperateTitle title='配置执行' />
      <Container>
        <ConfigSteps />
        <Vl />
        <Variables
          cmpVariables={currentVariables}
          ipVariables={currentIpVariables}
          hosts={currentHosts}
          setCmpVariables={setComponentVariables}
          setIpVariables={setComponentIpVariables}
          scopeType={clusterType}
        />
      </Container>
    </Root>
  );
}

export default connect(
  (state) => ({
    currentHosts: state.execComponent.currentHosts,
    currentIpVariables: state.execComponent.currentIpVariables,
    currentVariables: state.execComponent.currentVariables,
  }),
  {
    setComponentVariables,
    setComponentIpVariables,
  },
)(Main);

const Root = styled.div`
  border-radius: 8px;
  border: 1px solid #e1e1e1;
`;

const Container = styled.div`
  display: flex;
`;

const Vl = styled.div`
  background: #e7e7e7;
  width: 1px;
`;
